import { Injectable, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoITRDetails } from 'app/shared/models/global/auto-itr-details';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavigationService } from '../navigation.service';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { MessageService } from './message.service';

@Injectable({
    providedIn: 'root',
})
export class AutoITRService {
    personId: number;
    financialId: number;
    itrId: number;
    modalLocation: String = null;
    modalRef: BsModalRef;
    partyTypeId: number = null;

    constructor(public api: ApiService,
        public auth: AuthService,
        public common: CommonService,
        public message: MessageService,
        public modalService: BsModalService,
        public navigation: NavigationService,
        public router: Router,
        public activatedRoute: ActivatedRoute) {

        this.activatedRoute.queryParams.subscribe(params => {
            this.personId = +params['p_id'];
            this.financialId = +params['f_id'];
            this.itrId = +params['itr_id'];
        });
    }

    openModal(template: TemplateRef<any>, class_name) {
        this.modalRef = this.modalService.show(
            template,
            Object.assign({}, { ignoreBackdropClick: true, class: class_name })
        );
    }

    getAutoItrDetailsByUUID(uuid) {
        return new Promise((resolve, reject) => {
            this.api.get(`auto_itr/get_auto_itr_details/${uuid}`).subscribe((res) => {
                this.message.loading = false;
                if (res['status']) {
                    resolve(res);
                }
            }, (err) => {
                this.message.loading = false;
                this.message.displaySnackbar('OOPS something went wrong!');
                reject();
            });
        });
    }

    getAutoItrByUUID(uuid) {
        return new Promise((resolve, reject) => {
            this.api.get(`auto_itr/get_auto_selected_itr/${uuid}`).subscribe((res) => {
                this.message.loading = false;
                if (res['status']) {
                    const itr = res['data'];
                    resolve(res);
                }
            }, (err) => {
                this.message.loading = false;
                this.message.displaySnackbar('OOPS something went wrong!');
                reject();
            });
        });
    }

    getAutoItrDetailsByPidFid() {
        return new Promise((resolve, reject) => {
            this.api.get(`auto_itr/get_auto_itr_details/${this.personId}/${this.financialId}`).subscribe((res) => {
                this.message.loading = false;
                if (res['status']) {
                    resolve(res);
                }
            }, (err) => {
                this.message.loading = false;
                this.message.displaySnackbar('OOPS something went wrong!');
                reject();
            });
        });
    }

    saveAndChangeItr(autoITRDetails: AutoITRDetails) {
        return new Promise((resolve, reject) => {
            this.saveAutoItr(autoITRDetails).then(res => {
                const itr = res['data'];
                if (itr.id !== this.itrId) {
                    this.common.changeItr(itr);
                    resolve(res);
                } else {
                    this.message.displayInfoToaster('You are already on the selected Itr.');
                }
            }, (err) => {
                this.message.loading = false;
                this.message.displaySnackbar('OOPS something went wrong!');
                reject();
            });
        });
    }

    saveAutoItr(autoITRDetails: AutoITRDetails) {;
        return new Promise((resolve, reject) => {
            this.api.post(`auto_itr/saveupdate`, autoITRDetails).subscribe((res) => {
                this.message.loading = false;
                if (res['status']) {
                    resolve(res);
                }
            }, (err) => {
                this.message.loading = false;
                this.message.displaySnackbar('OOPS something went wrong!');
                reject();
            });
        });
    }

    get getModalLocation(): String {
        return this.modalLocation;
    }

    set setModalLocation(value: String) {
        this.modalLocation = value;
    }

    set partyType(value: number) {
        this.partyTypeId = value;
    }

    get partyType(): number {
        return this.partyTypeId;
    }
}
